import React, { useState } from 'react';
import AdminLayout from '../../components/AdminLayout/AdminLayout';
import Pagination from '../../components/Pagination/Pagination';
import './PaymentHistoryPage.css';

const PaymentHistoryPage = () => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const paymentData = [
    { id: 1, date: '12.12.2025', companyName: 'Gulf Building Supplies LLC', package: 'Premium', amount: '$299', method: 'Credit Card', status: 'Completed' },
    { id: 2, date: '11.12.2025', companyName: 'ABC Construction Co', package: 'Basic', amount: '$99', method: 'PayPal', status: 'Completed' },
    { id: 3, date: '10.12.2025', companyName: 'Elite Materials Trading', package: 'Premium', amount: '$299', method: 'Bank Transfer', status: 'Pending' },
    { id: 4, date: '09.12.2025', companyName: 'Modern Build Solutions', package: 'Enterprise', amount: '$599', method: 'Credit Card', status: 'Completed' },
    { id: 5, date: '08.12.2025', companyName: 'Quality Contractors LLC', package: 'Basic', amount: '$99', method: 'PayPal', status: 'Failed' },
    { id: 6, date: '07.12.2025', companyName: 'Prime Construction Group', package: 'Premium', amount: '$299', method: 'Credit Card', status: 'Completed' },
  ];

  const handleSelectItem = (id) => {
    setSelectedItems(prev => 
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedItems.length === paymentData.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(paymentData.map(item => item.id));
    }
  };

  return (
    <AdminLayout>
      <div className="payment-history-content">
        <div className="ph-page-header">
          <div className="ph-page-title-section">
            <h1 className="ph-page-title">Payment History</h1>
            <p className="ph-page-description">View and manage all payment transactions.</p>
          </div>
          <button className="ph-export-btn">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M7 10L12 15L17 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 15V3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Export</span>
          </button>
        </div>

        <div className="ph-content">
          <div className="ph-list-header">
            <h2 className="ph-list-title">All Payments</h2>
            <div className="ph-list-controls">
              <div className="ph-search-box">
                <input 
                  type="text" 
                  placeholder="Search by company..." 
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="9.16667" cy="9.16667" r="5.83333" stroke="#969696" strokeWidth="1.5"/>
                  <path d="M14.166 14.1665L17.4993 17.4998" stroke="#969696" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
              <div className="ph-dropdown">
                <span>Status</span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 7.5L10 12.5L15 7.5" stroke="#6D6D6D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="ph-dropdown">
                <span>Package</span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 7.5L10 12.5L15 7.5" stroke="#6D6D6D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="ph-table">
            <div className="ph-table-header">
              <div className="ph-th ph-th-checkbox">
                <div className="ph-checkbox" onClick={handleSelectAll}>
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.75" y="0.75" width="15.5" height="15.5" rx="2" stroke="#333333" strokeWidth="1.5"/>
                  </svg>
                  {selectedItems.length === paymentData.length && (
                    <svg className="ph-check" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M10 3L4.5 8.5L2 6" stroke="#1F396C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
              </div>
              <div className="ph-th">Date</div>
              <div className="ph-th">Company Name</div>
              <div className="ph-th">Package</div>
              <div className="ph-th">Amount</div>
              <div className="ph-th">Method</div>
              <div className="ph-th">Status</div>
              <div className="ph-th">Action</div>
            </div>

            <div className="ph-table-body">
              {paymentData.map((payment) => (
                <div key={payment.id} className="ph-table-row">
                  <div className="ph-td ph-td-checkbox">
                    <div className="ph-checkbox" onClick={() => handleSelectItem(payment.id)}>
                      <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <rect x="0.75" y="0.75" width="15.5" height="15.5" rx="2" stroke={selectedItems.includes(payment.id) ? "#1F396C" : "#969696"} strokeWidth="1.5" fill={selectedItems.includes(payment.id) ? "#E6F0F5" : "none"}/>
                      </svg>
                      {selectedItems.includes(payment.id) && (
                        <svg className="ph-check" width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <path d="M10 3L4.5 8.5L2 6" stroke="#1F396C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      )}
                    </div>
                  </div>
                  <div className="ph-td">{payment.date}</div>
                  <div className="ph-td ph-td-company">{payment.companyName}</div>
                  <div className="ph-td">
                    <span className={`ph-package-badge ${payment.package.toLowerCase()}`}>{payment.package}</span>
                  </div>
                  <div className="ph-td ph-td-amount">{payment.amount}</div>
                  <div className="ph-td">{payment.method}</div>
                  <div className="ph-td">
                    <span className={`ph-status-badge ${payment.status.toLowerCase()}`}>{payment.status}</span>
                  </div>
                  <div className="ph-td ph-td-action">
                    <button className="ph-view-btn">View</button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Pagination */}
          <Pagination currentPage={currentPage} totalPages={3} onPageChange={setCurrentPage} />
        </div>
      </div>
    </AdminLayout>
  );
};

export default PaymentHistoryPage;
